export default {
    // VendorMonthly查询
    vendorMonthlyShow: "/vendorMonthly/show",
    // vendorMonthly新增
    vendorMonthlyAdd: "/vendorMonthly/add",
    // vendorMonthly修改
    vendorMonthlyUpdate: "/vendorMonthly/updateVendor",
    // 修改回显查看
    vendorMonthlyShowById: "/vendorMonthly/showById",
    // vendor Type
    vendorVendorType:"/vendor/vendorType",
    // id,TypeList获取可查看文件的内容
    vendorMonthlyFile:"/file/getFilePathList",
    // 月薪修改查看反显数据
    getVendorMonthlyById:"/vendorMonthly/getMonthlyWorkerById",
    //新增月薪修改
    getMonthlyWorkerSalary:"/vendorMonthly/saveMonthlyWorkerSalary",
    // 修改vendorType
    getChangeVendorType:"/vendorMonthly/changeVendorType",
    // vendorMonthly下载
    vendorVendorTypeExport: "/vendorMonthly/export",
    // operatorRecords
    operatorRecords: "/common/operatorRecords",
}